import React from 'react';
import styled from '@emotion/styled';
import { EmotionBreakpoint } from 'dw-au-react-components';

const StyledHeroBannerwithCopy = styled.div`
	@media (min-width: 576px) {
		margin: -10px;
	}

	h5 {
		font-weight: bold;
		font-size: 24px;
		line-height: 32px;
		color: #000000;
	}

	p {
		font-size: 16px;
		line-height: 24px;
		letter-spacing: 0.15px;
		color: #545454;
	}

	> div {
		@media (min-width: 576px) {
			padding: 10px;
		}

		:nth-of-type(n + 2) {
			@media (max-width: 575px) {
				margin-top: 24px;
			}
		}
	}

	&.length-3 > div,
	&.length-4 > div {
		${EmotionBreakpoint('notDesktop')} {
			flex-basis: 50%;
		}
	}
`;

function HeroBannerwithCopy({ props: { items } }) {
	return (
		<div className='container'>
			<StyledHeroBannerwithCopy
				className={
					'd-sm-flex justify-content-center align-items-center flex-wrap flex-equal length-' +
					items.length
				}
			>
				{items.map((item, index) => {
					let {
						fields: {
							description,
							title,
							file: { url },
						},
					} = item;
					return (
						<div key={index}>
							<img
								src={url}
								alt={title}
								title={title}
								className='d-inline-block mw-100 mb-20'
							/>
							<h5 className='mb-16 lower'>{title}</h5>
							<p className='mb-0'>{description}</p>
						</div>
					);
				})}
			</StyledHeroBannerwithCopy>
		</div>
	);
}

export default HeroBannerwithCopy;
